<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col v-if="agent" cols="2" align="start" class="align-content-center">
                <div>
                    <v-img
                        :src="this.$store.getters.getClientImage"
                        class="rounded-circle mx-auto"
                        max-width="40"
                    />
                </div>
            </v-col>
            <v-col cols="10" align="center">
                <v-slide-group
                    :show-arrows="reply.message.attachment.payload.elements.length > 1"
                    center-active
                >
                    <v-slide-item
                        v-for="(element, index) in reply.message.attachment.payload.elements"
                        :key="index"
                        v-slot="{ toggle }"
                    >
                        <v-card
                            class="white--text rounded-xl ma-2"
                            color="grey lighten-5"
                            max-width="250px"
                            @click="toggle"
                        >
                            <v-img
                                width="150px"
                                height="150px"
                                contain
                                class="mx-auto mt-4 rounded-0 carousel-image"
                                :src="element.image_url"
                            >
                                <template #placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-progress-circular
                                            indeterminate
                                            color="blue-grey"
                                        />
                                    </v-row>
                                </template>
                            </v-img>
                            <v-card-title class="black--text text-body-1 font-weight-bold justify-center px-3 mb-4">
                                {{ element.title }}
                            </v-card-title>
                            <v-card-subtitle class="black--text px-3">
                                {{ element.subtitle }}
                            </v-card-subtitle>
                            <v-card-actions class="d-block">
                                <div class="d-flex flex-column flex-buttons mb-2">
                                    <v-btn
                                        v-for="(button, index) in element.buttons"
                                        :key="index"
                                        :color="mainColor"
                                        class="text-none"
                                        @click="clickButton(button)"
                                    >
                                        <div class="white--text">
                                            {{ button.title }}
                                        </div>
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-slide-item>
                </v-slide-group>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            agent: {
                type: Boolean,
                default: false
            },
            reply: {
                type: Object,
            },
            mainColor: {
                type: String,
                default: null
            }
        },
        data: () => ({
        }),
        methods: {
            clickButton(button) {
                if (button.url) {
                    window.open(button.url, '_blank', 'noreferrer');
                } else {
                    this.$emit('prepareMessage', {
                        text: button.payload,
                        freshchatAgentText: button.title
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .carousel-image {
        filter: brightness(98%); /* For Public images: Hide white background */
    }

    :deep(.v-card__title) {
        word-break: break-word;
    }

    :deep(.v-card__subtitle) {
        height: 100%;
    }

    @media (max-width: 460px) {
        :deep(.v-slide-group__prev),
        :deep(.v-slide-group__next)
        {
            min-width: 20px;
        }
    }
</style>

<style>
    .flex-buttons {
        gap: 5px;
        width: 90%;
    }
</style>